// extracted by mini-css-extract-plugin
module.exports = {"link":"_3dg_f","forcePink":"_1f6Y1","resetMargin":"_1pBlP"};